import React from 'react';
import type { Stripe } from '@stripe/stripe-js';
import { usePublicBookingStore } from '../../../store/publicBooking';
import { PublicBookingPaymentForm } from './PublicBookingPaymentForm';

export interface PublicBookingPaymentStepProps {
  stripePromise: Stripe | null;
  bookingId: string;
  bookingIds?: string[];
  amount: number;
  priceSubtotalLabel?: string;
  customerEmail: string;
  isAuthenticated: boolean;
  onPaymentSuccess: () => void;
  onPaymentError: (error: string) => void;
}

export function PublicBookingPaymentStep({
  stripePromise,
  bookingId,
  bookingIds,
  amount,
  priceSubtotalLabel,
  customerEmail,
  isAuthenticated,
  onPaymentSuccess,
  onPaymentError,
}: PublicBookingPaymentStepProps) {
  const hasPaymentProcessing = usePublicBookingStore((s) => s.hasPaymentProcessing);

  if (!hasPaymentProcessing) {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-foreground mb-6">Payment Information</h3>
        <p className="text-center text-sm text-muted-foreground py-8">Redirecting…</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-foreground mb-6">Payment Information</h3>

      {!stripePromise ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4" />
          <p className="text-muted-foreground">Loading payment system...</p>
          <p className="text-sm text-muted-foreground mt-2">
            If this takes too long, please refresh the page.
          </p>
        </div>
      ) : (
        <PublicBookingPaymentForm
          stripePromise={stripePromise}
          bookingId={bookingId}
          bookingIds={bookingIds}
          amount={amount}
          priceSubtotalLabel={priceSubtotalLabel}
          customerEmail={customerEmail}
          isAuthenticated={isAuthenticated}
          onSuccess={onPaymentSuccess}
          onError={onPaymentError}
        />
      )}
    </div>
  );
}
